import React, { Fragment } from "react";
import { Image, View, Text, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  logo: {
    marginTop: 30,
    marginBottom: 10,
    marginLeft: 10,
    width: 100
  },
  logoText : {
    right: 10,
    top: 40,
    fontSize: 14,
    fontWeight:"bold",
    position: "absolute",
    color: "#fff"
  },
  heading: {
    backgroundColor: "#d4d7de",
    color: "#223279",
    textAlign: "center"
  },
  text1: {
    paddingTop: 10,
    paddingBottom: 5,
    fontWeight: "bold"
  },
  text2: {
    fontSize: 10,
    paddingBottom: 10
  }
});

function PdfHeader({ mainHeading, subHeading, greyHeading }) {
  return (
    <Fragment>
      <View style={{ backgroundColor: "#303b91" }}>
        <Image source="/images/logo.png" style={styles.logo}></Image>
        {
          greyHeading === false && mainHeading ? <Text style={styles.logoText}>{mainHeading}</Text> : null 
        }
      </View>
      {greyHeading !== false ? (
        <View style={styles.heading}>
          {mainHeading ? <Text style={styles.text1}>{mainHeading}</Text> : null}
          {subHeading ? <Text style={styles.text2}>{subHeading}</Text> : null}
        </View>
      ) : null}
    </Fragment>
  );
}

export default PdfHeader;



// WEBPACK FOOTER //
// ./src/components/parts/pdfmaker/common/pdfHeader.jsx